export class Controller {

    /** @ngInject */
    constructor(SmsResetPin) {
        this.SmsResetPin = SmsResetPin;
    }

    $onInit() {
    }

    reset() {
        this.isSaving = true;
        this.SmsResetPin
            .sendResetPinCode(this.resolve.companyId, this.resolve.companyUserId)
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/sms-reset-pin/sms-reset-pin.controller.js